import { all } from 'redux-saga/effects';
import authSaga from '@iso/redux/auth/saga';
import accountSaga from '@iso/redux/account/saga';
import commonSaga from '@iso/redux/common/saga';
import userSaga from '@iso/redux/users/saga';
import roleSaga from '@iso/redux/roles/saga';
import careerSaga from '@iso/redux/careers/saga';
import subcriptionPackageSaga from '@iso/redux/subcriptionPackages/saga';
import learnerSaga from '@iso/redux/learners/saga';
import dashboardSaga from '@iso/redux/dashboard/saga';
import subscriptionRequestSaga from '@iso/redux/subscriptionRequests/saga';
import FAQSagas from '@iso/redux/FAQs/saga';

// SPEAKING
import readAloudSaga from '@iso/redux/speaking/readAloud/saga';
import describeImageSaga from '@iso/redux/speaking/describeImage/saga';
import answerShortQuestionSaga from '@iso/redux/speaking/answerShortQuestion/saga';
import repeatSentenceSaga from '@iso/redux/speaking/repeatSentence/saga';
import retellLectureSaga from '@iso/redux/speaking/retellLecture/saga';
//LISTENING
import summarizeSpokenTextSaga from '@iso/redux/listening/summarizeSpokenText/saga';
import writeFromDictationSaga from '@iso/redux/listening/writeFromDictation/saga';
import multipleChoiceMultipleAnswerSaga from '@iso/redux/listening/multipleChoiceMultipleAnswer/saga';
import multipleChoiceSingleAnswerSaga from '@iso/redux/listening/multipleChoiceSingleAnswer/saga';
import highlightCorrectSummarySaga from '@iso/redux/listening/highlightCorrectSummary/saga';
import fillInTheBlanksSaga from '@iso/redux/listening/fillInTheBlanks/saga';
import selectMissingWordSaga from '@iso/redux/listening/selectMissingWord/saga';
import highlightInCorrectWordSaga from '@iso/redux/listening/highlightInCorrectWord/saga';
// WRITING
import summarizeWrittenTextSaga from '@iso/redux/writing/summarizeWrittenText/saga';
import writeEssaySaga from '@iso/redux/writing/writeEssay/saga';
import blanksDropDownSaga from '@iso/redux/reading/fillInTheBlanksDropDown/saga';
import blanksDragDropSaga from '@iso/redux/reading/fillInTheBlanksDragDrop/saga';
import reOrderParagraph from '@iso/redux/reading/reOrderParagraph/saga';
import multipleAnswer from '@iso/redux/reading/multipleAnswer/saga';
import singleAnswer from '@iso/redux/reading/singleAnswer/saga';
// MOCKTEST
import mockTest from '@iso/redux/mockTest/saga';
//Qna
import QnA from '@iso/redux/QnA/saga';

export default function* rootSaga(getState) {
	yield all([
		authSaga(),
		accountSaga(),
		commonSaga(),
		userSaga(),
		roleSaga(),
		careerSaga(),
		subcriptionPackageSaga(),
		learnerSaga(),
		dashboardSaga(),
		subscriptionRequestSaga(),
		FAQSagas(),
		// SPEAKING
		readAloudSaga(),
		describeImageSaga(),
		answerShortQuestionSaga(),
		repeatSentenceSaga(),
		retellLectureSaga(),
		//LISTENING
		summarizeSpokenTextSaga(),
		writeFromDictationSaga(),
		multipleChoiceMultipleAnswerSaga(),
		highlightCorrectSummarySaga(),
		fillInTheBlanksSaga(),
		multipleChoiceSingleAnswerSaga(),
		selectMissingWordSaga(),
		highlightInCorrectWordSaga(),
		// WRITING
		summarizeWrittenTextSaga(),
		writeEssaySaga(),
		blanksDropDownSaga(),
		blanksDragDropSaga(),
		reOrderParagraph(),
		multipleAnswer(),
		singleAnswer(),
		//MOCKTEST
		mockTest(),
		QnA()
	]);
}
